export default "__VITE_ASSET__COipe$tQ__"